import React, { PureComponent } from 'react';
import { Divider } from 'semantic-ui-react';
import AttributeGroup from '../../components/AttributeGroup';
import { specialCaseShouldHide } from '../../components/Attributes/nonStandardAttributes/utils/tools';
import { withApi } from '../../context/AppContext';
import './TabContent.css';

class TabContent extends PureComponent {
  render() {
    const { activeTab, appApi, configuration } = this.props;

    const tabChildren = [];
    appApi.config.getTab(activeTab).attributeGroups.forEach(groupName => {
      const { attributes, autoHide } = appApi.config.getAttributeGroup(
        groupName
      );
      if (autoHide) {
        let shouldHide = true;
        for (let idx = 0; idx < attributes.length && shouldHide; ++idx) {
          shouldHide = !appApi.config.getAttributeAvailableValues(
            attributes[idx],
            configuration
          ).length;
          if (
            shouldHide &&
            appApi.config.getAttribute(attributes[idx]).type === 'list'
          )
            shouldHide =
              shouldHide && specialCaseShouldHide(this.props, attributes[idx]);
        }
        if (shouldHide) return;
      }
      if (tabChildren.length)
        tabChildren.push(<Divider key={`divider-${groupName}`} />);
      tabChildren.push(
        <AttributeGroup key={groupName} {...this.props} groupName={groupName} />
      );
    });

    return <div className="tabContent">{tabChildren}</div>;
  }
}

export default withApi(TabContent);



// WEBPACK FOOTER //
// ./src/containers/TabContent/index.js